// Normalize legacy flags at data boundaries; application state uses numeric flags.
export function normalizeCheckFlag(value: any): 0 | 1 {
  return value === 1 || value === true || value === "1" ? 1 : 0;
}

export function normalizeCheckItems<T extends { isCheck?: any }>(items?: T[]): T[] | undefined {
  return items && items.map(item => ({ ...item, isCheck: normalizeCheckFlag(item.isCheck) }));
}
